import React, { useState } from "react";
import { Card, Container, CardBody, CardSubtitle, CardTitle, CardText, Button, ModalBody, Modal } from "reactstrap";
import TuneIcon from '@mui/icons-material/Tune';
import { DataGrid } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import { Autocomplete, Checkbox } from "@mui/material";
import { TextField } from "@mui/material";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import ReplayIcon from '@mui/icons-material/Replay';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { styled } from '@mui/system';
import handImg from '../../../assets/images/front_hand.svg';
import sucessImg from '../../../assets/images/success-green-check-mark-icon 1.svg'

const DateUpdate = () => {
    document.title = "Dashboard | Procurement Dashboard";
    const top100Films = [
        { label: 'PO123844' },
        { label: 'PO654344' },
        { label: 'PO128448' },
        { label: 'PO342344' },
        { label: 'PO652344' },]

    const columns = [
        {
            field: 'Sl_No', headerName: (<div><Checkbox /><span>SL.No</span></div>),
            // width: 100,
            sortable: false,
            resizable: false,
            flex: 1,
            renderCell: (params) => {
                return <div><Checkbox /><span>1</span></div>;
            },
        },
        {
            field: 'Product_Name',
            headerName: 'Product Name',
            headerClassName: 'break-header',
            cellClassName: 'product_name_wrap',
            width: 160,
            // flex: 1,
            sortable: false,
            resizable: false,
            editable: false,
            renderCell: (params) => {
                const productName = params.value;
                return (
                    <div style={{ cursor: 'pointer' }}>
                        {productName}
                    </div>
                );
            },
        },
        {
            field: 'quantity',
            headerName: 'Quantity',
            headerClassName: 'table-header-background',
            sortable: false,
            sortable: false,
            headerAlign: 'center',
            cellClassName: 'center-aligndata',
            flex: 1,
            //   width: 160,
        },
        {
            field: 'dP_Value',
            headerName: 'DP Value',
            sortable: false,
            resizable: false,
            flex: 1,
            // width: 160,
        },
        {
            field: 'MOP',
            headerName: 'FOB',
            sortable: false,
            resizable: false,
            // width: 160,
            flex: 1,
        },
        {
            field: 'vendor_name',
            headerName: 'Vendor Name',
            sortable: false,
            resizable: false,
            //   cellClassName: 'product_name_wrap center-aligndata ',
            //   width: 160,
            flex: 1,
            // width: 160,

        },
        {
            field: 'payment_term',
            headerName: 'Payment Term',
            headerClassName: 'break-header',
            sortable: false,
            resizable: false,
            headerAlign: 'center',
            cellClassName: 'center-aligndata',
            flex: 1,
            // width: 160,
        },
        {
            field: 'po_no',
            headerName: 'PO No',
            sortable: false,
            resizable: false,
            headerAlign: 'center',
            cellClassName: 'center-aligndata',
            flex: 1,
            // width: 160,

        },
        {
            field: 'actual_date',
            headerName: 'Actual Date',
            sortable: false,
            resizable: false,
            headerAlign: 'center',
            cellClassName: 'center-aligndata',
            flex: 1,
            // width: 160,

        },
        // {
        //     field: 'Status',
        //     headerName: 'Action',
        //     headerClassName: 'table-header-background',
        //     sortable: false,
        //     resizable: false,
        //     width: 160,
        //     renderCell: (params) => {
        //         return <div className="mt-2">
        //                 <button className="no_button p-1 ps-2 pe-2 d-flex align-items-center"><span className="me-1"><i class="ri-pencil-line"></i></span><span>Edit Button</span></button>
        //         </div>;
        //     },
        // },
    ];

    const approvalrows = [
        { id: 1, Sl_No: 1, Product_Name: 'HOBS HB-MARICA', quantity: 2, dP_Value: 6055500, MOP: 658010, vendor_name: 'Zhonghan Wantai', payment_term: '30% 30 Days', Actual_Date: '-',po_no:'PO1234' },
        { id: 2, Sl_No: 1, Product_Name: 'HOBS HB-MARICA', quantity: 2, dP_Value: 6055500, MOP: 658010, vendor_name: 'Zhonghan Wantai', payment_term: '30% 30 Days', Actual_Date: '-',po_no:'PO1234' },
    ];
    const [inputValue, setInputValue] = useState('');
    const [selectedValue, setSelectedValue] = useState(null);
    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <div>
                        <div style={{ marginTop: '10px' }} className="d-flex align-items-center justify-content-between">
                            <div className="d-flex align-items-center gap-2">
                                <h4 className="mb-0 requisition_text">Date Update</h4>
                                <div> 
                                     <Autocomplete
                                        className="data_field"
                                        disablePortal
                                        id="combo-box-demo"
                                        options={top100Films}
                                        value={selectedValue}
                                        onChange={(event, newValue) => {
                                            setSelectedValue(newValue);
                                        }}
                                        inputValue={inputValue}
                                        onInputChange={(event, newInputValue) => {
                                            setInputValue(newInputValue);
                                        }}
                                        sx={{ width: 230 }}
                                        renderInput={(params) => <TextField {...params} label="Search By PO Number" />}
                                    />
                                    </div>
                            </div>
                                <div className="d-flex align-items-center gap-2 justify-content-end">
                                <div>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker className='invoice_datepicker'
                                          label="User Arrival Date"
                                        // value={dayjs(selectedDate)}
                                        // maxDate={selectedEndDate}

                                        // onChange={(e) => {
                                        //     setSelectedDate(e)
                                        // }}
                                        />
                                    </LocalizationProvider>
                                </div>
                                <div><button className="save_button">Save</button></div>
                                </div>
                        </div>

                        <Box sx={{ height: 400, width: '100%', marginBottom: '10px', marginTop: '10px' }}>
                            <DataGrid
                                className="table_header_background"
                                headerClassName="custom-header-cell"
                                rows={approvalrows}
                                columns={columns}
                                initialState={{
                                    pagination: {
                                        paginationModel: {
                                            pageSize: 5,
                                        },
                                    },
                                }}
                                pageSizeOptions={[5]}
                                disableRowSelectionOnClick
                                disableColumnMenu
                                disableColumnResize={true}
                                componentsProps={{
                                    cell: {
                                        disableClick: true,
                                    },
                                }}
                                sx={{
                                    '& .MuiDataGrid-cell': {
                                        '& .MuiDataGrid-cell--textOverflow': {
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap',
                                        },
                                    },
                                }}
                            />
                        </Box>
                    </div>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default DateUpdate;
